import apiClient from "./client";
import type {
  DisasterManualTriggersResponse,
  GetDisasterManualTriggersParams,
} from "../types/disaster";

export const getDisasterManualTriggers = async (
  params: GetDisasterManualTriggersParams
): Promise<DisasterManualTriggersResponse> => {
  const { data } = await apiClient.get<DisasterManualTriggersResponse>(
    "/disaster-manual-triggers",
    {
      params: {
        disaster_id: params.disaster_id,
        attach_status: params.attach_status,
        order: params.order,
        sort: params.sort,
        page: params.page,
        limit: params.limit,
      },
    }
  );
  return data;
};
